import { createPaymentSchedule, differenceInDaysBetweenTwoDates, differenceInMonthsBetweenTwoDates } from '@buddy-technology/buddy_helpers';
import { getFieldsByQuery } from '@buddy-technology/ion-helpers';
import filterValidPaymentOptions from './filterValidPaymentOptions';

// Temporary map to avoid having to update all IONs right now, new IONs should never go into this map
// they should explicitly define allowed values for Payment Options in the ION
const PAYMENT_OPTION_MAP = {
	AON_PURCHASEPROTECTION: ['MONTHLY'],
	AAC_AD_AND_D: ['SINGLE', 'QUARTERLY'],
	KITCHEN_SINK: ['SINGLE', 'QUARTERLY'],
	WRB_VIGILANCE_OCCACCIDENT: ['SINGLE'],
	GAIG_POMI_ACCIDENT: ['SINGLE'],
	AON_PURCHASE_PROTECTION_KOALAFI: ['SINGLE'],
	GAIG_GAIG_SI: ['SINGLE'],
	ALLSTATE_ASC_AUTO_DEMO: ['SINGLE'],
	ALLSTATE_EXEC_AUTO_DEMO: ['SINGLE'],
	II_AIRLOCKACCIDENT: ['SINGLE'],
	STARR_BUDDY_ADANDD_AAC: ['SINGLE', 'QUARTERLY'],
	CHUBB_MYREG_LEAGUE_DEMO: ['SINGLE'],
	INTERPLANETARYINSURANCE_AUTO: ['SINGLE', 'MONTHLY'],
	WRB_BUDDY_TICKETCANCEL_FORGE: ['SINGLE'],
	TESTING_VIGILANCE_OCCUPATIONAL_ACCIDENT: ['SINGLE'],
	ALLSTATE_RENTERS_PREFILL: ['SINGLE'],
};

const timezone = 'UTC'; // this is needed by the payment schedule creation, it is okay for it to be UTC in this instance as that is the default timezone we used in the backend, and it won't impact the calculations

function getPremiumByInterval(totalPremium, ion, startDate, endDate) {
	const [paymentOption] = getFieldsByQuery({ id: 'policy::paymentOption' }, ion, true);
	const terms = paymentOption?.rules?.allowedValues;
	const termsAvailable = PAYMENT_OPTION_MAP[ion.id] || terms;

	if (!termsAvailable) {
		throw new Error('No payment terms available on ION to calculate schedule, ensure the ION explicitly defines payment option rules.');
	}

	let termsToUse;
	if (startDate && endDate) {
		termsToUse = filterValidPaymentOptions({
			numberOfDaysBetweenTwoDates: differenceInDaysBetweenTwoDates({ endDate, startDate, timezone }),
			numberOfMonthsBetweenTwoDates: differenceInMonthsBetweenTwoDates({ endDate, startDate, timezone }),
			availablePaymentOptions: termsAvailable,
		});
	} else {
		// if we don't have start and end date, we can't filter based on policy length, so just use all available terms.
		termsToUse = termsAvailable;
	}

	const paymentByInterval = termsToUse.reduce((runningValue, currentValue) => {
		const intervalPricing = createPaymentSchedule({
			startDate,
			endDate,
			paymentOption: currentValue,
			premiumTotal: totalPremium,
			timezone,
		});

		if (intervalPricing) {
			return {
				...runningValue,
				[currentValue]: {
					equalPaymentAmount: intervalPricing.paymentAmounts[1] || intervalPricing.paymentAmounts[0],
					firstPayment: intervalPricing.paymentAmounts[0],
					remainingMonths: intervalPricing.totalPayments - 1,
				},
			};
		}
		return runningValue;
	}, {});

	return paymentByInterval;
}

export default getPremiumByInterval;
